import React from 'react';
import AdminUsersList from './admin/AdminUsersList';
import AdminOrgsList from './admin/AdminOrgsList';

/**
 * Platform admin pages, one per nav item:
 *   /admin/users          User Management (detail pages at /admin/users/:id)
 *   /admin/organizations  Organization Management (detail pages at /admin/organizations/:id)
 */
const AdminPanel = ({ section = 'users' }) => (
  <div className="pb-6 space-y-6">{section === 'orgs' ? <AdminOrgsList /> : <AdminUsersList />}</div>
);

export default AdminPanel;
